module.exports = __webpack_public_path__ + "img/centered-logo-nav-mitsu.bf56ec69.png";